module.exports = __webpack_public_path__ + "static/media/mena-wallet.475202dc.png";